import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';

import { CLEAR_SEARCH, SET_TASK_PARTNERS } from './actionTypes';

const setPartners = createAction(SET_TASK_PARTNERS, (response) => response.body);

export const clearSearch = createAction(CLEAR_SEARCH);

export const getPartnersForTaskId = (taskId) => (dispatch) => {
	return dispatch(
		fetch.actions.get(fetch.constants.urls.taskPolicyPartnerList, {
			replaceParams: { id: taskId },
			takeLatest: true,
			onSuccess: [setPartners],
		}),
	);
};
